import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class AssignClerks extends BaseModel {
  telephone_bids_lot_spacing = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    telephone_bids_lot_spacing: 'min_value:0|required'
  };

  attributeLabels = {
    telephone_bids_lot_spacing: i18n.t('Lot Spacing'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(AssignClerks);
